import { render } from "./icon-label.vue?vue&type=template&id=5f6397a1&ts=true"
import script from "./icon-label.vue?vue&type=script&setup=true&lang=ts"
export * from "./icon-label.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/space-model/model-item/icon-label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f6397a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f6397a1', __exports__)) {
    console.log('reload')
    api.reload('5f6397a1', __exports__)
  }
  
  module.hot.accept("./icon-label.vue?vue&type=template&id=5f6397a1&ts=true", () => {
    console.log('re-render')
    api.rerender('5f6397a1', render)
  })

}


export default __exports__